import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Form, Modal } from "react-bootstrap";
import * as fileDownload from "js-file-download";
import Colum from "./colum";
import anime from "animejs";
import * as axios from "axios";
import "./myplan.css";
import QueryString from "qs";

class Personal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			show: false,
			visible: false,
			email: "",
			name: "",
			formValid: false,
			first_download: localStorage.getItem("first_download") === "true",
			emailValid: false,
		};
		this.handleClose = this.handleClose.bind(this);
		this.handleShow = this.handleShow.bind(this);
		this.downloadPlan = this.downloadPlan.bind(this);
		this.changeDayEfect = this.changeDayEfect.bind(this);
		this.SendToSendy = this.SendToSendy.bind(this);
		this.handleUserInput = this.handleUserInput.bind(this);
	}

	animation2 = anime.timeline({
		duration: 509,
		easing: "linear",
	});
	handleScroll = () => {
		const currentScrollPos = window.pageYOffset;
		const visible =
			currentScrollPos > this.props.firstPageRef.current.offsetTop - 400;
		this.setState({ visible });
	};

	handleClose() {
		this.setState({ show: false });
	}

	handleShow() {
		this.setState({ show: true });
	}

	componentDidMount() {
		window.addEventListener("scroll", this.handleScroll);
	}

	componentWillUnmount() {
		window.removeEventListener("scroll", this.handleScroll);
	}

	handleUserInput(e) {
		const name = e.target.name;
		const value = e.target.value;
		this.setState({ [name]: value }, () => this.validateField(name, value));
	}

	changeDayEfect(day) {
		if (day > -1 && day < 5) {
			anime({
				targets: ".colum",
				scale: [{ value: 0.9 }, { value: 1, delay: 150 }],
				easing: "easeInOutSine",
				duration: 400,
				complete: () => {
					this.props.changeDay(day);
				},
			});
		}
	}

	downloadPlan() {
		axios
			.post(
				"https://fullmusculo.com/api/pdfdownload",
				{
					data: this.props.personalPlan,
				},
				{
					headers: {
						"Content-Type": "application/json",
						Accept: "application/pdf",
					},
					responseType: "blob",
				}
			)
			.then((res) => {
				const blob = new Blob([res.data], { type: "application/pdf" });
				const objectUrl = window.URL.createObjectURL(blob);
				window.open(objectUrl);
				fileDownload(blob, "TuRutinaFullMusculo.pdf");
			})
			.catch((err) => console.log(err));
	}

	moveGlide(id) {
		this.props.changeDay(id);
	}

	setLeterDay(i) {
		switch (i) {
			case 1:
				return "L";
			case 2:
				return "M";
			case 3:
				return "X";
			case 4:
				return "J";
			case 5:
				return "V";
			case 6:
				return "S";
			case 7:
				return "D";
			default:
				return "L";
		}
	}

	createIconsBullet() {
		var items = [];
		for (let i = 0; i < this.props.personalPlan.length; i++) {
			items.push(
				<div
					key={i}
					className={
						this.props.dayIndex === i
							? "bullet active in_back "
							: "bullet in_back "
					}
					onClick={() => this.moveGlide(i)}
				>
					{this.setLeterDay(i + 1)}
				</div>
			);
		}
		return items;
	}

	SendToSendy() {
		if (this.props.userRestricId !== 0) {
			this.downloadPlan();
		} else if (this.state.formValid) {
			const body = QueryString.stringify({
				email: this.state.email,
				gdpr: true,
				list: this.state.list,
				subform: "yes",
				boolean: true,
			});
			axios
				.post("https://fullmusculo.com/sendy2/subscribe", body, {
					headers: { "Content-Type": "application/x-www-form-urlencoded" },
				})
				.then((response) => {
					if (response.data) this.downloadPlan();
				});
		}
	}

	render() {
		return (
			<>
				{/* MODAL */}
				<Modal size='xl' show={this.state.show} onHide={this.handleClose}>
					<Modal.Header className='plan'>
						<Button
							variant='primary'
							onClick={this.handleClose}
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								width: "100%",
							}}
						>
							<i
								style={{ fontSize: "25px" }}
								className='fas fa-chevron-circle-down'
							></i>{" "}
							<>
								<div style={{ paddingLeft: "5px" }}> Mi rutina</div>
							</>
						</Button>
					</Modal.Header>
					<Modal.Body style={{ paddingTop: "0", paddingBottom: "0" }}>
						<div className='daycontent container-fluid'>
							<div className='content colum'>
								<Colum id='colum' list={this.props.personalPlan} />
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Form
							className='form-ejercicio'
							style={{ display: "flex", alignItems: "center" }}
						>
							<Button className='pdfprint' onClick={this.downloadPlan}>
								<i className='fas fa-file-pdf'></i> Descargar tu rutina
							</Button>
						</Form>
					</Modal.Footer>
				</Modal>
				{/*  */}
				<div
					className='float2'
					style={{
						bottom: this.state.visible || this.state.show ? "-100px" : "",
					}}
				>
					{this.createIconsBullet()}
				</div>
				<div
					className='float'
					style={{
						bottom: this.state.visible || this.state.show ? "-100px" : "",
					}}
				>
					<Button
						variant='primary'
						onClick={this.handleShow}
						style={{
							display: "flex",
							alignItems: "center",
						}}
					>
						<i
							style={{ fontSize: "25px" }}
							className='fas fa-chevron-circle-up'
						></i>
						<>
							<div style={{ paddingLeft: "5px" }}> Mi rutina</div>
						</>
					</Button>
				</div>
			</>
		);
	}
}

const mapStateToProps = (state) => ({
	personalPlan: state.personalPlan,
	dayIndex: state.dayIndex,
	firstPageRef: state.firstPageRef,
	userRestricId: state.userRestricId,
});
const mapDispatchToProps = (dispatch) => ({
	changeDay(day) {
		dispatch({
			type: "CHANGE_DAY",
			day: day,
		});
	},
});
export default connect(mapStateToProps, mapDispatchToProps)(Personal);
